//测试环境
const upload_url = 'https://api.scjjkfq.com/web/uploads';
const admin_api = 'https://api.scjjkfq.com/web';
// const admin_api = 'https://qinc-api.xiaocx.tech/Admin';
export default {
    upload_url,
    admin_api,
}
